import { useQuery } from '@tanstack/react-query';
import { BoloResource } from '@mark43/cad-api';
import { useApiClient } from '@m43/core';

interface UseBoloQueryProps {
    boloId?: number;
    queryKey?: string;
}

export const useBoloQuery = ({ boloId, queryKey }: UseBoloQueryProps) => {
    const apiClient = useApiClient();
    const query = useQuery({
        queryKey: ['bolo-panel-view', queryKey ?? boloId],
        queryFn() {
            return apiClient
                .request<BoloResource.GetBoloPanel>({
                    method: 'POST',
                    url: 'bolo/panel',
                    data: {
                        boloId,
                    },
                })
                .then((data) => {
                    return data.data.data;
                });
        },
        // TODO RND-21592 This will happen in use-integrated-streams, and this value will be false.
        enabled: true,
    });

    return query;
};
